import { graphql } from 'src/gql'
import { SortFindManyDistributionSubcategoryStatusInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQLDropdownOptions } from 'src/queries/cat/lookups/helpers'

const document = graphql(/* graphql */`
  query distributionSubcategoryStatuses($sort: SortFindManyDistributionSubcategoryStatusInput) {
    lookups {
      DistributionSubcategoryStatus {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type DistributionSubcategoryStatuses = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['DistributionSubcategoryStatus']>['many']>

const useDistributionSubcategoryStatuses = useGraphQLDropdownOptions(
  document,
  'lookups.DistributionSubcategoryStatus.many',
  {
    sort: SortFindManyDistributionSubcategoryStatusInput.OrderAsc
  }
)

export { useDistributionSubcategoryStatuses, document as distributionSubcategoryStatusesDocument }
